<template>
    <div class="game-summary-round has-text-left">

        <span v-if="gameType === 'Solo'">
            <span class="is-size-5 game-summary-round-title">R{{ (index+1) }}</span>
            <span v-for="match in round.matches" :key="match.id">
            <span v-for="(matchPlayer, index) in match.matchPlayers" :key="index">
                <span v-for="(axethrow, index) in matchPlayer.throws" :key="index">
                <span :class="axethrow.basicScore === 5 ? 'game-summary-throw-bullseye' : 'game-summary-throw'">
                    <span class="is-size-5">{{ axethrow.basicScore }}</span>
                </span>
                </span>
                <span class="is-size-6 game-summary-round-total">
                <span>{{ calculateTotalThrowsMatch(matchPlayer.throws) }}</span>
                </span>
            </span>
            </span>
        </span>

        <span v-if="gameType === GameType.ROUNDROBIN || gameType === GameType.TOURNAMENT">
            <div class="is-size-5 game-summary-round-title">{{ round.title }}</div>
            <div v-for="match in round.matches" :key="match.id">
                <div v-for="(matchPlayer, index) in match.matchPlayers" :key="index">
                    <div>{{ matchPlayer.player.name }}</div>
                    <span v-for="(axethrow, index) in matchPlayer.throws" :key="index">
                    <span
                        :class="axethrow.basicScore === 5 ? 'game-summary-throw-bullseye' : 'game-summary-throw'">
                        <span class="is-size-5">{{ axethrow.basicScore }}</span>
                    </span>
                    </span>
                    <span class="is-size-6 game-summary-round-total">
                    <span>{{ calculateTotalThrowsMatch(matchPlayer.throws) }}</span>
                    </span>
                </div>
                <div v-if="gameType === GameType.ROUNDROBIN">
                    <br/>
                </div>
            </div>
        </span>

    </div>
</template>

<style scoped>
.game-summary-round-title {
    font-weight: bold;
    margin-bottom: 10px;
}
.game-summary-throw-bullseye {
    border: solid black 1px;
    padding: 2px;
    margin-left: 10px;
}
.game-summary-throw {
    border: solid black 1px;
    padding: 2px;
    margin-left: 10px;
}
.game-summary-round-total {
    padding-left: 5px;
}

</style>

</style>

<script>
import { GameType } from '@/enum/gameType.js';

export default {
  name: "ScorecardRound",
  props: {
      gameType: null,
      index: 0,
      round: null
  },
  data () {
    return {
        GameType,
      publicPath: process.env.BASE_URL,
    }
  },
  methods: {
    //duplicated 
    calculateTotalThrowsMatch: function(throws) {
        var total = 0;
        for (var a = 0; a < throws.length; a++) {
            var pThrow = throws[a];
            //console.log("............pThrow " + pThrow.basicScore);
            total += parseInt(pThrow.basicScore);
        }
        return total;
    }
  }
}
</script>